// add class for sticky header bg
const adds = document.querySelector('.header-wrapper');
    document.addEventListener('scroll', () => {
       if (window.scrollY > 50) {
            adds.classList.add('sticky-bg');
        }else{
          adds.classList.remove('sticky-bg');
        }
    });

//login and policy pages header background
for (const bgElement of [".shopify-policy__title",  ".customers-account", ".customers-addresses", ".login", ".register", ".cart", ".page", ".page-sourav", ".page-haritha", "#shopify-section-template--16352500580575__banner", "#shopify-section-template--16352500613343__main"]){
 let name = document.querySelector(bgElement);
  if (name){
   document.querySelector('.header-wrapper').setAttribute("style", "background-color: #b0382d; position: relative;");
    document.addEventListener('scroll', () => {
   if (window.scrollY > 50) {
     document.querySelector('.header-wrapper').setAttribute("style", "background-color: #b0382d; position: absolute;");  
        }else{
      document.querySelector('.header-wrapper').setAttribute("style", "background-color: #b0382d; position: relative;");
        }
    });
  }
}

